import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Autocomplete,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs"; // Import dayjs for date manipulation
import {
  advanceSearch,
  findAsyouType,
} from "../../../_helper/services/advanceSearchv2";
import { post } from "../../../_helper/api_helper";
import { ShowError, ShowSucess } from "../../../_helper/helper";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// const positions = [
//   { label: 'Manager', value: 'manager' },
//   { label: 'Developer', value: 'developer' },
//   { label: 'Designer', value: 'designer' },
// ]; // Sample options for autocomplete

let timeout;
const debounce = (func, delay) => {
  return (...args) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

const RetentionForm = ({
  handleClose,
  modalData,
  refreshDetail,
  departmentOptions,
  setAdHocPoint,
}) => {
  console.log(departmentOptions, "departmentOptions1221");
  const [loading, setLoading] = useState(false);
  const today = dayjs().format("YYYY-MM-DD");
  const [positions, setPositions] = useState([]);
  const [initialPositions,setInitialPosition] = useState([])
  const [positionLoading,setPositionLoading] = useState(false)
  const [departmentDivisionOptions, setDepartmentDivisionOptions] = useState(
    []
  );
  const [divisionLoading, setDivisionLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs().format("MM/DD/YYYY"));

  const validationSchema = Yup.object({
    salaryDate: Yup.date().required("Salary date is required"),
    grade: Yup.string().required("Grade is required"),
    step: Yup.string().required("Step is required"),
    rating: Yup.string().required("Rating is required"),
    score: Yup.number().required("Score is required"),
    position: Yup.string().required("Position is required"),
    department: Yup.string().required("Department is required"),
    departmentdivision: Yup.string().required(
      "Department division is required"
    ),
  });

  const formik = useFormik({
    initialValues: {
      salaryDate: selectedDate,
      grade: "",
      step: "",
      rating: "",
      score: 0,
      position: "",
      department: "",
      departmentLabel: "",
      departmentdivision: "",
      departmentdivisionLabel: "",
      remark: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      const { grade, step, departmentLabel, departmentdivisionLabel, ...rest } =
        values;
      const formattedValues = {
        ...rest,
        department: values.departmentLabel,
        departmentdivision: values.departmentdivisionLabel,
        gradeStep: `${values.grade}-${values.step}`,
        salaryDate: dayjs(values.salaryDate).format("YYYY-MM-DD"),
        employeeid: modalData?.EmpNo,
      };

      console.log("Form values:", formattedValues);
      try {
        await post(
          `${process.env.REACT_APP_API_DOTNET_URL}/LkRetentionAdHoc/Create`,
          formattedValues
        );
        setAdHocPoint(values.score * 1);
        ShowSucess("Created Successfully");
        handleClose();
        refreshDetail();
      } catch (error) {
        ShowError("Something went wrong!");
      } finally {
        setLoading(false);
      }
    },
  });

  const getDepartmentDivisionOptions = async (department) => {
    setDivisionLoading(true); // Start loader
    try {
      const payload = {
        tableName: "Lk_DPDV",
        searchParams: "",
        columns: "*",
        location: "global",
        pageNumber: 1,
        pageSize: 10000,
        sortData: "",
        additionalWhere: `Dept_Code = '${department}'`,
        qID: 0,
      };
      const response = await advanceSearch(payload);
      const { results } = response ?? { results: [] };
      const options = results.map((item) => ({
        label: item?.NAME ?? "",
        value: item?.DEPT_KEY ?? "",
      }));
      setDepartmentDivisionOptions(options);
    } catch (error) {
      console.error("Failed to fetch department divisions:", error);
    } finally {
      setDivisionLoading(false); // Stop loader
    }
  };

  const getPositionData = async (searchTerm = "") => {
    const payload = {
      tableName: "vw_positions",
      searchParams: "[]",
      columns: "*",
      pageNumber: 1,
      pageSize: 5000,
      sortData: "TitleWithGrade ASC",
      additionalWhere: "nullif(trim(TitleWithGrade),'') is not null",
      qID: 0,
      role: "",
      location: "global",
      id: "POSITIONS-Retention",
    };
    setPositionLoading(true)
    try {
      const response = await findAsyouType(
        "vw_positions",
        "TitleWithGrade",
        "RangeNext",
        searchTerm
      );
    //   const { results } = response ?? { results: [] };
      if (response?.length > 0) {
        // setServiceData(results[0])
        const getPositions = response.map((item) => ({
          label: item?.keyField?.trim() ?? "",
          value: item?.keyField?.trim() ?? "",
          grade: item?.valueField?.trim() ?? ""
        })).filter((pos)=>pos.label!="");
        if(!searchTerm)
        setInitialPosition([[...getPositions]])
        setPositions([...getPositions]);
      }
      console.log(response, "response1221rete");
    } catch (error) {
    } finally {
        setPositionLoading(false)
    }
  };

  useEffect(() => {
    getPositionData();
  }, []);

  const handleFilter = debounce((inputValue) => {
      getPositionData(inputValue.toLowerCase());
  }, 300); // 300ms debounce delay
console.log(inputValue,'inputValue1221')

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        {/* Row 1: Salary Date and Position */}
        <Grid item xs={4}>
        <DatePicker
            label="Salary Date"
            inputFormat="MM/DD/YYYY"
            value={selectedDate}
            onChange={(newValue) => {
              setSelectedDate(dayjs(newValue).format("MM/DD/YYYY"));
              formik.setFieldValue("salaryDate", dayjs(newValue).format("MM/DD/YYYY")); 
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={formik.touched.salaryDate && Boolean(formik.errors.salaryDate)}
                helperText={formik.touched.salaryDate && formik.errors.salaryDate}
              />
            )}
          />
        </Grid>
        <Grid item xs={8}>
        <Autocomplete
            fullWidth
            options={positions}
            getOptionLabel={(option) => option.label}
            inputValue={inputValue} 
            value={selectedValue} 
            onInputChange={(event, value) => {
              setInputValue(value); 
              handleFilter(value); 
            }}
            onChange={(event, value) => {
              if (value) {
                formik.setFieldValue("position", value.label);
                formik.setFieldValue("grade", value.grade);
                setSelectedValue(value); 
              } else {
                formik.setFieldValue("position", "");
                formik.setFieldValue("grade", "");
                setSelectedValue(null); 
              }
              setInputValue(value ? value.label : ""); 
            }}
            onBlur={() => {
              
              if (!selectedValue && inputValue) {
                setInputValue(inputValue); 
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Position"
                error={formik.touched.position && Boolean(formik.errors.position)}
                helperText={formik.touched.position && formik.errors.position}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {positionLoading ? (
                        <CircularProgress size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>

        {/* Row 2: Grade, Step, Rating, and Score */}
        <Grid item xs={2}>
          <TextField
            fullWidth
            id="grade"
            name="grade"
            label="Grade"
            value={formik.values.grade}
            onChange={formik.handleChange}
            error={formik.touched.grade && Boolean(formik.errors.grade)}
            helperText={formik.touched.grade && formik.errors.grade}
            // disabled={true}
            InputProps={{
              sx: {
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "black",
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            fullWidth
            id="step"
            name="step"
            label="Step"
            value={formik.values.step}
            onChange={formik.handleChange}
            error={formik.touched.step && Boolean(formik.errors.step)}
            helperText={formik.touched.step && formik.errors.step}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            id="rating"
            name="rating"
            label="Rating"
            value={formik.values.rating}
            onChange={formik.handleChange}
            error={formik.touched.rating && Boolean(formik.errors.rating)}
            helperText={formik.touched.rating && formik.errors.rating}
          />
        </Grid>
        <Grid item xs={5}>
          <FormControl fullWidth>
            {/* <Select
              labelId="score-label"
              id="score"
              name="score"
              value={formik.values.score}
              onChange={(event) =>
                formik.setFieldValue("score", event.target.value)
              }
              error={formik.touched.score && Boolean(formik.errors.score)}
            >
              <MenuItem value={0}>
                <em>None</em>
              </MenuItem>
              <MenuItem value={4}>Outstanding</MenuItem>
              <MenuItem value={2}>Satisfactory</MenuItem>
            </Select> */}
            <TextField
              fullWidth
              id="score"
              name="score"
              label="score"
              value={formik.values.score}
              onChange={formik.handleChange}
              error={formik.touched.score && Boolean(formik.errors.score)}
              helperText={formik.touched.score && formik.errors.score}
            />
          </FormControl>
        </Grid>

        {/* Row 3: Department and Department Division */}
        <Grid item xs={6}>
          <Autocomplete
            fullWidth
            options={departmentOptions.map((dept) => ({
              label: dept.DepartmentName?.trim(),
              value: dept.Dept_Code,
            }))}
            getOptionLabel={(option) => option.label || ""} // Safe handling of label
            value={
              departmentOptions
                .map((dept) => ({
                  label: dept.DepartmentName?.trim(),
                  value: dept.Dept_Code,
                }))
                .find((opt) => opt.value === formik.values.department) || null
            }
            onChange={(event, value) => {
              formik.setFieldValue("department", value ? value.value : ""); // Store Dept_Code
              formik.setFieldValue("departmentLabel", value ? value.label : ""); // Store label
              formik.setFieldValue("departmentdivision", ""); // Reset division
              if (value) getDepartmentDivisionOptions(value.value); // Fetch division with Dept_Code
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Department"
                error={
                  formik.touched.department && Boolean(formik.errors.department)
                }
                helperText={
                  formik.touched.department && formik.errors.department
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            fullWidth
            options={departmentDivisionOptions}
            getOptionLabel={(option) => option.label}
            value={
              departmentDivisionOptions.find(
                (opt) => opt.label === formik.values.departmentdivisionLabel
              ) || null
            }
            onChange={(event, value) => {
              formik.setFieldValue(
                "departmentdivision",
                value ? value.value : ""
              );
              formik.setFieldValue(
                "departmentdivisionLabel",
                value ? value.label : ""
              );
            }}
            loading={divisionLoading}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Department Division"
                error={
                  formik.touched.departmentdivision &&
                  Boolean(formik.errors.departmentdivision)
                }
                helperText={
                  formik.touched.departmentdivision &&
                  formik.errors.departmentdivision
                }
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {divisionLoading ? <CircularProgress size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>

        {/* Row 4: Reamrks Field */}
        <Grid item xs={12}>
          <TextField
            multiline
            rows={2}
            variant="outlined"
            fullWidth
            id="remark"
            name="remark"
            label="Remarks"
            value={formik.values.remark}
            onChange={formik.handleChange}
            error={formik.touched.remark && Boolean(formik.errors.remark)}
            helperText={formik.touched.remark && formik.errors.remark}
          />
        </Grid>

        {/* Row 5: Cancel and Submit Buttons */}
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button
                variant="outlined"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} /> : null}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
    </LocalizationProvider>
  );
};

export default RetentionForm;
